var map = {
	"./Abort.svg": "0353",
	"./Exit.svg": "212b",
	"./Group 396.svg": "463a",
	"./Group 422.svg": "266b",
	"./Home.svg": "dd8b",
	"./Logo-full.svg": "4f94",
	"./Logo-text.svg": "1dce",
	"./Logo.svg": "8f62",
	"./Plus.svg": "dd1c",
	"./Send.svg": "7804",
	"./address-card-alt.svg": "d578",
	"./bar.svg": "8e5c",
	"./bell-alt.svg": "a100",
	"./bell.svg": "777b",
	"./calendar-alt.svg": "1222",
	"./calendar-day.svg": "ccc3",
	"./calendar-month.svg": "0f7c",
	"./calendar-week.svg": "94b2",
	"./calendar-year.svg": "39ac",
	"./calendar.svg": "6a19",
	"./check.svg": "77a5",
	"./chevron-down.svg": "49ce",
	"./chevron-left.svg": "febf",
	"./chevron-right.svg": "dbe4",
	"./chevron-up.svg": "050d",
	"./comments-alt.svg": "307b",
	"./comments.svg": "df76",
	"./edit.svg": "0871",
	"./email-solid.svg": "aad8",
	"./end-meeting-alt.svg": "201b5",
	"./end-meeting.svg": "39ef",
	"./envelope.svg": "b2d6",
	"./file-alt.svg": "344c",
	"./file-download.svg": "dce1",
	"./file-signature-alt.svg": "cb4f",
	"./file-signature.svg": "1418",
	"./file-upload.svg": "3fd7",
	"./file.svg": "6838",
	"./hand-paper-alt.svg": "c120",
	"./hand-paper.svg": "79bc",
	"./history-solid.svg": "13d7",
	"./home-regular.svg": "3b52",
	"./ic_fullscreen.svg": "811e",
	"./ic_fullscreen_exit.svg": "6c26",
	"./laptop_mac.svg": "7fb8",
	"./logo-splash-screen.svg": "0a46",
	"./logo-without-text.svg": "14f7",
	"./logout.svg": "2d24",
	"./my-card.svg": "ef47",
	"./not-check.svg": "7117",
	"./poll-alt.svg": "9c7d",
	"./poll.svg": "6290",
	"./qrcode.svg": "2061",
	"./question-circle-alt.svg": "481b",
	"./question-circle.svg": "b371",
	"./search.svg": "2a21",
	"./task-alt.svg": "05d8",
	"./task.svg": "2475",
	"./user-friends-alt.svg": "310a",
	"./user-friends.svg": "a797",
	"./user-tie.svg": "27ad",
	"./valid.svg": "dfe7",
	"./vote-alt.svg": "b811",
	"./vote.svg": "6bfc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "55e8";